// extracted by mini-css-extract-plugin
export default {"aiIconButton":"AIStarButton__aiIconButton___oEljy"};